import { render, staticRenderFns } from "./ElementSelector.vue?vue&type=template&id=47e98265&"
import script from "./ElementSelector.vue?vue&type=script&lang=js&"
export * from "./ElementSelector.vue?vue&type=script&lang=js&"
import style0 from "./ElementSelector.vue?vue&type=style&index=0&id=47e98265&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports